import { ReactNode } from 'react'
import { Grid, Skeleton } from '@mui/material'

import { ImageField } from './image-field.component'

import { useStyles } from './styles'
import { useTranslation } from 'react-i18next'

interface IProps {
  isLoading: boolean
  loadersNumber?: number
  label?: string | ReactNode
  image: string
  fields: ReactNode
  actions: ReactNode
}

export const NFTMetadataSection = ({
  isLoading,
  loadersNumber = 4,
  label,
  image,
  fields,
  actions,
}: IProps) => {
  const classes = useStyles({})
  const [t] = useTranslation()

  if (!label) {
    label = t('account-form-nft-metadata-label')
  }

  return (
    <Grid className={classes.section}>
      <div className={classes.label}>{label}</div>
      <div className={classes.fieldsContainer}>
        <Grid className={classes.fieldsWrapper}>
          {isLoading ? (
            <>
              {Array(loadersNumber)
                .fill(0)
                .map((_, index) => (
                  <Skeleton variant="rounded" width={370} height={60} key={index} />
                ))}
            </>
          ) : (
            <>
              <div className={classes.fieldsXWrapper}>
                <div className={classes.fieldsYWrapper}>{fields}</div>
                <div className={classes.fieldsYWrapper}>
                  <ImageField image={image} />
                </div>
              </div>
            </>
          )}
        </Grid>
        <Grid className={classes.actionsWrapper}>{actions}</Grid>
      </div>
    </Grid>
  )
}
